export enum AppEventEnum {
    ProdutoAlterado = 0,
    MovAtualAlterada = 10,
    MovAtualProdAlterado = 11,
    MovAtualStatusAlterado = 12,
    PermiteEntradaDigitada = 20,
    LoginPush = 21,
    EnvironmentConfig = 22,
    LayoutAlterado = 23
}